"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function for interacting with application and module metadata.
 */
const MetadataManager = (() => {
    let applicationMetadata = null;
    let moduleMetadata = [];
    /**
     * Register application metadata.
     *
     * @param applicationProps Application metadata to register.
     */
    const registerApplication = (applicationProps) => {
        applicationMetadata = applicationProps;
    };
    /**
     * Register module metadata.
     *
     * @param moduleProps Module metadata to register.
     */
    const registerModule = (moduleProps) => {
        moduleMetadata = [
            ...moduleMetadata.filter(m => m.moduleId !== moduleProps.moduleId),
            moduleProps
        ];
    };
    /**
     * Update and/or add some properties of the application metadata and saves it.
     * The new properties must be a subset of {@link IApplicationMetadata}.
     *
     * @param applicationProps The properties to update.
     */
    const updateApplication = (applicationProps) => {
        applicationMetadata = Object.assign(Object.assign({}, applicationMetadata), applicationProps);
    };
    /**
     * Update and/or add some properties of the module metadata and saves it.
     * The new properties must be a subset of {@link IModuleClient}.
     *
     * @param moduleProps The properties to update.
     * @param moduleId The module id.
     */
    const updateModule = (moduleProps, moduleId) => {
        const currentProps = getModuleMetadata(moduleId);
        moduleMetadata = [
            ...moduleMetadata.filter(m => m.moduleId !== moduleId),
            Object.assign(Object.assign({}, currentProps), moduleProps)
        ];
    };
    /**
     * Get the currently registered application metadata.
     *
     * @returns The registered application metadata if it exists.
     */
    const getApplicationMetadata = () => {
        return applicationMetadata;
    };
    /**
     * Get the registered module metadata for given module id.
     *
     * @param moduleId The module that you want to retrieve the metadata.
     * @returns The registered metadata as an object if it exists.
     */
    const getModuleMetadata = (moduleId) => {
        if (!moduleId) {
            return undefined;
        }
        return moduleMetadata.find(m => m.moduleId == moduleId) || null;
    };
    /**
     * Clear application and module metadata stored.
     */
    const clear = () => {
        applicationMetadata = null;
        moduleMetadata = [];
    };
    return {
        registerApplication,
        registerModule,
        updateApplication,
        updateModule,
        getApplicationMetadata,
        getModuleMetadata,
        clear
    };
})();
exports.default = MetadataManager;
//# sourceMappingURL=MetadataManager.js.map